import {Typography, VerticalSpacer} from 'epic-ue-ui';
import React from 'react';
import styled from 'styled-components';
import QuestionsFields from './QuestionsFields';
import {withLocalization} from '@epic-core/localization';

const Styled = styled.div``;

export interface QuestionsBlockProps {
    questions?: any[];
    formRenderProps: {
        handleSubmit;
        hasValidationErrors;
        submitFailed;
        form;
        submitSucceeded;
        values;
    };
    enterManuallyButtonlabel?: string;
    isInputsDisabled?: boolean;
    sectionRequiredLabel?: string;
    uploadFileValidationLabel?: string;
    sectionHeading?: string;
    getMessage: (key: string) => string;
}

const QuestionsBlock = ({
    getMessage,
    questions = [],
    formRenderProps,
    enterManuallyButtonlabel,
    isInputsDisabled,
    sectionRequiredLabel,
    uploadFileValidationLabel = getMessage('epic.jobs.form.uploadFileValidation'),
    sectionHeading = getMessage('epic.jobs.form.questionsTitle')
}: QuestionsBlockProps): JSX.Element => {
    return (
        <Styled className="questions">
            <Typography variant="h3">{sectionHeading}</Typography>
            <VerticalSpacer variant="heading" />

            <QuestionsFields
                questions={questions}
                formRenderProps={formRenderProps}
                sectionRequiredLabel={sectionRequiredLabel}
                isInputsDisabled={isInputsDisabled}
                enterManuallyButtonlabel={enterManuallyButtonlabel}
                uploadFileValidationLabel={uploadFileValidationLabel}
            />
        </Styled>
    );
};

export default withLocalization(QuestionsBlock);
